/*
The MIT License

Copyright (c) 2013-2014 Paul Yoder

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in
all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
THE SOFTWARE.
*/
(function () {
    var showErrorsModule;
    showErrorsModule = angular.module('ui.bootstrap.showErrors', []);
    showErrorsModule.directive('showErrors', [
      '$timeout',
      'showErrorsConfig',
      function ($timeout, showErrorsConfig) {
          var getShowSuccess, linkFn;
          getShowSuccess = function (options) {
              var showSuccess;
              showSuccess = showErrorsConfig.showSuccess;
              if (options && options.showSuccess != null) {
                  showSuccess = options.showSuccess;
              }
              return showSuccess;
          };
          linkFn = function (scope, el, attrs, formCtrl) {
              var blurred, inputEl, inputName, inputNgEl, options, showSuccess, toggleClasses;
              blurred = false;
              options = scope.$eval(attrs.showErrors);
              showSuccess = getShowSuccess(options);
              inputEl = el[0].querySelector('[name]');
              inputNgEl = angular.element(inputEl);
              inputName = inputNgEl.attr('name');
              if (!inputName) {
                  throw 'show-errors element has no child input elements with a \'name\' attribute';
              }
              inputNgEl.bind('blur', function () {
                  // only validate this field if it was modified.
                  if(!formCtrl[inputName].$pristine) {
                      blurred = true;
                      return toggleClasses(formCtrl[inputName].$invalid);
                  }
              });
              scope.$watch(function () {
                  return formCtrl[inputName] && formCtrl[inputName].$invalid;
              }, function (invalid) {
                  if (!blurred) {
                      return;
                  }
                  return toggleClasses(invalid);
              });
              scope.$on('show-errors-check-validity', function () {
                  return toggleClasses(formCtrl[inputName].$invalid);
              });
              scope.$on('show-errors-reset', function () {
                  return $timeout(function () {
                      el.removeClass('has-error');
                      el.removeClass('has-success');
                      return blurred = false;
                  }, 0, false);
              });
              return toggleClasses = function (invalid) {
                  el.toggleClass('has-error', invalid);
                  if (showSuccess) {
                      return el.toggleClass('has-success', !invalid);
                  }
              };
          };
          return {
              restrict: 'A',
              require: '^form',
              compile: function (elem, attrs) {
                  if (!elem.hasClass('form-group')) {
                      throw 'show-errors element does not have the \'form-group\' class';
                  }
                  return linkFn;
              }
          };
      }
    ]);
    showErrorsModule.provider('showErrorsConfig', function () {
        var _showSuccess;
        _showSuccess = false;
        this.showSuccess = function (showSuccess) {
            return _showSuccess = showSuccess;
        };
        this.$get = function () {
            return { showSuccess: _showSuccess };
        };
    });
}.call(this));


// WEBPACK FOOTER //
// ./js/vendor/showErrors.js